import { HttpErrorResponse } from "@angular/common/http";
import { IAuthStateModel } from "../../models/auth.model";
import { IChartSetting, IPayerAdminSetting, IPayerSetting, ISystemUserSetting, IUserChartSetting } from "../../../core/modules/admin-modules/settings/models/settings.model";
import { ILoginRequest, IPatientLoginRequest } from "../../models/login-request.model";

export namespace Auth {

    export class Login {
        static readonly type = '[Auth] Login';
        constructor(public payload: ILoginRequest) { }
    }

    export class PatientLogin {
        static readonly type = '[Auth] PatientLogin';
        constructor(public payload: IPatientLoginRequest) { }
    }

    export class Logout {
        static readonly type = '[Auth] Logout';
        constructor(public isPatientUser: boolean = false, public sessionTimeout: boolean = false) { }
    }

    export class CheckSession {
        static type = '[Auth] CheckSession';
    }

    export class LogoutSuccess {
        static type = '[Auth] LogoutSuccess';
        constructor(public isPatientUser: boolean = false) { }
    }

    export class ResetState {
        static readonly type = '[Auth] ResetState';
    }

    export class SetUserSettings {
        static type = '[Auth] SetUserSettings';
        constructor(public userSettings: ISystemUserSetting[]) { }
    }

    export class SetChartSettings {
        static type = '[Auth] SetChartSettings';
        constructor(public chartSettings: IChartSetting[] | IUserChartSetting[]) { }
    }

    export class SetPayerSettings {
        static type = '[Auth] SetPayerSettings';
        constructor(public payerSettings: IPayerSetting[] | IPayerAdminSetting[]) { }
    }

    // Events
    export class LoginRedirect {
        static type = '[Auth] LoginRedirect';
        constructor(public isPatientUser: boolean = false) { }
    }

    export class LoginSuccess {
        static type = '[Auth] LoginSuccess';
        constructor(public authDetails: IAuthStateModel) { }
    }

    export class LoginFailed {
        static type = '[Auth] LoginFailed';
        constructor(public error: Error | HttpErrorResponse, public isPatientUser: boolean = false) { }
    }

    export class RefreshToken {
        static readonly type = '[Auth] Refresh Token';
    }

    export class FetchProviders {
        static readonly type = '[Auth] Fetch Providers';
    }

    export class FetchPayers {
        static readonly type = '[Auth] Fetch Payers';
    }
}